import { WHY_THIS_EXISTS_CARDS } from '../data';

export function WhyThisExistsSection() {
  return (
    <section className="bg-white">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="rounded-2xl bg-brand-50 px-6 py-10 sm:rounded-3xl sm:px-10 sm:py-12 lg:px-14 lg:py-14">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand-600 sm:text-sm">
            Why This Exists
          </p>

          <h2 className="mt-5 max-w-xl text-3xl font-semibold leading-[1.1] tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
            Most kids don&rsquo;t fall behind in September.
            <br className="hidden sm:block" />{' '}
            They fall behind in June.
          </h2>

          <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-500 sm:text-lg">
            Three months without a single math problem is enough to undo a whole
            grade level. By the time fall starts, the class is already moving &mdash; and
            your child is already chasing.
          </p>

          <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {WHY_THIS_EXISTS_CARDS.map((card) => (
              <div
                key={card.number}
                className="rounded-2xl bg-white p-7 shadow-sm ring-1 ring-slate-200/60"
              >
                <p className="text-sm font-medium text-brand-600">
                  {card.number} &mdash; {card.label}
                </p>
                <h3 className="mt-3 text-lg font-semibold text-slate-900">
                  {card.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-600">
                  {card.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}